









import Vue from 'vue';
import Component from 'vue-class-component';
import authStoreTypes from '../../vuex/authorization/types';  
import { isInDevelopmentMode } from '@/detox-helper';

@Component({
    props: {
        jwt: String,
        displayName: String
    }
})
export default class AppCallback extends Vue {
    private tempDevJWT = process.env.VUE_APP_DEV_ACCESS_TOKEN;

    mounted(): void { 
        let jwt = null;
        
        if (!this.$props.jwt || this.$props.jwt === '') {
            // On production the usage of dev tokens won't work
            if (isInDevelopmentMode()) {
                jwt = this.tempDevJWT;
                console.info('Using temponary dev token');
            } else {
                console.error('Token not provided in route, should show error in webview');
                this.$router.push({ name: '403' });
                return;
            }
        } else {
            jwt = this.$props.jwt;
        }
        
        this.$store.dispatch(authStoreTypes.actions.HANDLE_APP_CALLBACK_LOGIN, { jwt });
        this.$store.dispatch(authStoreTypes.actions.DECODE_JWT);
        this.$router.push({ name: 'ForumIndex' });
    }
}
